<template>
    <template-card-v2 :oneLog="oneLog" :linkedtype="linkedtype" :linkedid="linkedid">
        <template #icon>
            <CompassObject object="marketing" size="small" />
        </template>
        <template #label>
            <person-list-light
                v-if="oneLog.hasOwnProperty('contacts')"
                :list="oneLog.contacts.params.list"
                placeholderSingular="Collaborateur"
                placeholderPlural="Collaborateurs"
            >
            </person-list-light>
            <person-list-light
                v-else-if="oneLog.hasOwnProperty('thirds')"
                :list="oneLog.thirds.params.list"
                placeholderSingular="Société"
                placeholderPlural="Sociétés"
            >
            </person-list-light>
        </template>

        <template #content>
            <div>
                <div
                    class="marketing-card__content-description typographies-paragraph-medium-regular"
                >
                    {{ getWording(oneLog.event, oneLog.eventDetails) }}
                </div>
            </div>
        </template>

        <!-- DROPDOWN -->
        <template v-if="canSeeDropdown" #aside>
            <div>
                <el-dropdown>
                    <CompassIconButton icon="action" size="small"></CompassIconButton>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item
                                v-if="canTogglePin"
                                :disabled="!!intervalCallidES"
                                @click="
                                    togglePin(isPinned, {
                                        userForename: userForename,
                                        userName: userName,
                                    })
                                "
                            >
                                {{ pinStatusLabel }}
                            </el-dropdown-item>
                            <el-dropdown-item v-if="oneLog.canSee" @click="previewEvent(oneLog)">
                                {{ $l10n.__('Voir') }}
                            </el-dropdown-item>
                            <el-dropdown-item v-if="oneLog.can_edit" @click="editEvent(oneLog)">
                                {{ $l10n.__('Modifier') }}
                            </el-dropdown-item>
                            <el-dropdown-item v-if="oneLog.can_edit" @click="deleteEvent(oneLog)">
                                {{ $l10n.__('Supprimer') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </template>
    </template-card-v2>
</template>

<script>
import TemplateCardV2 from './TemplateCardV2.vue';
import TimelineCardMixin from './TimelineCardMixin.js';
import TimelineWordingMixin from './TimelineWordingMixin';
import PersonListLight from 'vcomponents/utilities/PersonListLight.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    components: {
        TemplateCardV2,
        PersonListLight,
    },
    mixins: [TimelineCardMixin, TimelineWordingMixin],
    computed: {
        ...mapStateUser({
            timezone: 'timezone',
            userForename: 'forename',
            userName: 'name',
        }),
    },
};
</script>

<style lang="scss" scoped>
.marketing-card {
    &__content {
        &-description {
            margin-top: var(--spacing-1);
        }
    }
}
</style>
